import React from "react";
import "../styles/loading.css";

const LoadingOverlay = ({ visible }) => {
  if (!visible) return null; // Hidden when not active

  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default LoadingOverlay;
